<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="List Vendor AWB"></app-page-title>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-sm-12">
                                <div class="text-sm-end">
                                    <a routerLink="add"><button type="button"
                                            class="btn btn-success btn-sm"><i class="mdi mdi-plus mr-1"></i>
                                            Add</button></a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 grid-container">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context" [gridOptions]="gridOptions"
                                [defaultColDef]="defaultColDef" [suppressMenuHide]="true"  [pagination]="true" (gridReady)="onGridReady($event)">
                            </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>
  